import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach bearer as fallback (cookies remain primary)
export const setBearer = (token) => {
  if (token) {
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    localStorage.setItem("bsvm_token", token);
  } else {
    delete api.defaults.headers.common["Authorization"];
    localStorage.removeItem("bsvm_token");
  }
};

const saved = typeof window !== "undefined" ? localStorage.getItem("bsvm_token") : null;
if (saved) api.defaults.headers.common["Authorization"] = `Bearer ${saved}`;

export const errText = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
  return JSON.stringify(d);
};
